import React, { Component } from "react";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import Select from "react-select";
import ReactCountryFlag from "react-country-flag";
import axios from "axios";
import localStore from "src/utils/local-storage";
import HeaderMobileComponent from "src/components/layout/header-mobile";
import Boxes from "./boxes";
import Analytics from "./analytics";
import Compare from "./compare";
import CompareCat from "./compare-cat";
import ChartLine from "src/page/dashboard/charts/chart-line";
import ApiService from "../../services/ApiService";
import RecordRow from "src/page/dashboard/record-row";
import TableCategory from "./table-category";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Layout from "src/page/home/components/Layout";

const expiredTime = 1; // minutes - validate cache time will greater than expired time

function pad(a, b) {
  return (1e15 + a + "").slice(-b);
}
class Dashboard extends Component {
  categoryOptions = [
    { value: "", label: "Tất cả chuyên mục" },
    { value: "giai-tri", label: "Sao" },
    { value: "nguoi-mau-hoa-hau", label: "Người mẫu - Hoa hậu" },
    { value: "thoi-trang", label: "Fashion - Beauty" },
    { value: "sac-mau-cuoc-song", label: "Cận cảnh cuộc sống" },
    { value: "vong-quanh-the-gioi", label: "Vòng quanh Thế giới" },
    { value: "am-nhac", label: "Âm Nhạc" },
    { value: "dien-anh", label: "Phim Ảnh" },
    { value: "sao-sport", label: "Sao Sport" },
    { value: "song-khoe", label: "Sức khỏe" },
    { value: "sao-hoc-duong", label: "Học đường" },
    { value: "guong-mat-thuong-hieu", label: "Gương mặt thương hiệu" },
    { value: "kinh-doanh", label: "BĐS - Tài chính" },
    { value: "cong-nghe", label: "Công nghệ" },
    { value: "du-lich-kham-pha", label: "Du lịch - Khám phá" },
    { value: "an-choi-kham-pha", label: "Ăn - Chơi" },
  ];

  categoriesOptions = [
    { index: 1, value: "giai-tri", label: "Sao", kpi: 1100000 },
    {
      index: 5,
      value: "nguoi-mau-hoa-hau",
      label: "Người mẫu - Hoa hậu",
      kpi: 250000,
    },
    { index: 8, value: "thoi-trang", label: "Fashion - Beauty", kpi: 350000 },
    {
      index: 3,
      value: "sac-mau-cuoc-song",
      label: "Cận cảnh cuộc sống",
      kpi: 300000,
    },
    {
      index: 4,
      value: "vong-quanh-the-gioi",
      label: "Vòng quanh Thế giới",
      kpi: 120000,
    },
    { index: 6, value: "am-nhac", label: "Âm Nhạc", kpi: 500000 },
    { index: 7, value: "dien-anh", label: "Phim Ảnh", kpi: 1100000 },
    { index: 12, value: "sao-sport", label: "Sao Sport", kpi: 250000 },
    { index: 10, value: "song-khoe", label: "Sức khỏe", kpi: 20000 },
    { index: 13, value: "sao-hoc-duong", label: "Học đường", kpi: 80000 },
    {
      index: 15,
      value: "guong-mat-thuong-hieu",
      label: "Gương mặt thương hiệu",
      kpi: 0,
    },
    {
      index: 17,
      value: "kinh-doanh",
      label: "BĐS - Tài chính",
      kpi: 0,
    },
    { index: 11, value: "cong-nghe", label: "Công nghệ", kpi: 100000 },
    { index: 21, value: "du-lich-kham-pha", label: "Du lịch - Khám phá", kpi: 0 },
    {
      index: 14,
      value: "an-choi-kham-pha",
      label: "Ăn - Chơi",
      kpi: 20000,
    },
    { index: 19, value: "", label: "Tất cả chuyên mục", kpi: 4990000 },
    { index: 20, value: "khac", label: "Khác", kpi: 0 },
  ];
  typesOptions = ["sum", "fb", "baomoi", "coccoc", "direct", "google"];

  oneDayRange = [
    new Date(new Date().setDate(new Date().getDate() - 1)),
    new Date(new Date().setDate(new Date().getDate() - 1)),
  ];
  threeDaysRange = [
    new Date(new Date().setDate(new Date().getDate() - 3)),
    new Date(new Date().setDate(new Date().getDate() - 1)),
  ];
  aWeekAgoRange = [
    new Date(new Date().setDate(new Date().getDate() - 7)),
    new Date(new Date().setDate(new Date().getDate() - 1)),
  ];

  aMonthAgoRange = [
    new Date(new Date().setDate(new Date().getDate() - 30)),
    new Date(new Date().setDate(new Date().getDate() - 1)),
  ];

  confirmAction() {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes"),
        },
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1>Bạn không có quền truy cập.</h1>
          <div
            className="bg-c7c6c5 bg-c7c6c5 txt-center pt-3 pb-3"
            onClick={() => {
              onClose();
              window.location.href = "/posts?page=1&limit=20";
            }}
          >
            Trở lại
          </div>
        </div>
      ),
      closeOnEscape: false,
      closeOnClickOutside: false,
    };

    confirmAlert(options);
  }

  constructor(props) {
    super(props);

    let startDate = new Date();
    let endDate = new Date();
    startDate = new Date(startDate.setDate(startDate.getDate() - 7));
    endDate = new Date(endDate.setDate(endDate.getDate() - 1));

    this.state = {
      date: [startDate, endDate],
      reports: [],
      canAccess: false,
      reportsByCat: [],
      sumreportsByCat: {
        sum: 0,
        fb: 0,
        google: 0,
        count: {
          countList: 0,
          countFBList: 0,
        },
      },

      reportsBySource: {
        sum: 0,
        fb: 0,
        baomoi: 0,
        coccoc: 0,
        direct: 0,
        google: 0,
      },

      reportsBySourceCat: [],
      sumreportsBySourceCat: {
        now: 0,
        past: 0,
      },

      staleCategories: [],
      staleCatsSource: [],
      staleTypes: [],
      hasReportDataCategories: [],
      hasReportDataCatsSource: [],
      hasReportDataTypes: [],
      snackBarStatus: false,
      snackBarData: {},
      categories: [],
    };

    this.getMetrics = this.getMetrics.bind(this);
    this.getMetricsByCat = this.getMetricsByCat.bind(this);
    this.setStateReportGA = this.setStateReportGA.bind(this);
  }

  componentDidMount() {
    ApiService.get(`configurations?label_eq=gaCategories`).then((result) => {
      if (result && result[0] && result[0].value && result[0].active) {
        let categories = JSON.parse(result[0].value);
        this.setState({ categories });
        // let valueHomepage = result[0];
        // if (valueHomepage.value != "") {
        //   if (valueHomepage.value != _user.email) {
        //     this.confirmAction(valueHomepage.value);
        //   } else {
        //     // this.canEditHomepage(valueHomepage, _user)
        //     // this.setState({ homepageConfig: valueHomepage });
        //     // this.currentUserAlreadyEditing();
        //   }
        // } else {
        //   // this.canEditHomepage(valueHomepage, _user)

        // }
      }
    });
    this.getMetrics(this.state.date);
    const _user = localStore.get("_user");
    if (_user) {
      this.setState({ canAccess: _user.can_view_ga }, () => {
        if (!_user.can_view_ga) {
          this.confirmAction();
        }
      });
    }

    this.getMetricsByCat(this.state.date, this.categoriesOptions);
    // console.log(this.state.reportsByCat);
  }

  UNSAFE_componentWillMount() {
    let accesstoken = Cookies.get("jwt");
    if (!accesstoken || accesstoken === "") {
      this.props.history.push("/login");
    }
    document.title = "Dashboard";
  }

  onChange = (date) => {
    if (date) {
      this.setState({ date });
      this.getMetrics(date);
      this.getMetricsByCat(date, this.categoriesOptions);
    }
  };

  onChangeCategory = (selected) => {
    // console.log(selected);
    if (selected) {
      const category = selected.value;
      this.getMetrics(this.state.date, category);
    }
  };

  async getMetrics(daterange, category) {
    const range = daterange.map(
      (date) =>
        `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(
          date.getDate(),
          2
        )}`
    );
    const startDate = range[0];
    const endDate = range[1];
    if (!category) {
      category = "";
    }
    const params = new URLSearchParams(window.location.search);
    const url =
      process.env.REACT_APP_API +
      `/${params.get("version") ? params.get("version") : "gas"}/ga1`;

    try {
      const response = await axios.get(
        url,
        {
          params: {
            startDate,
            endDate,
            category,
          },
        },
        {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }
      );
      const reports = response.data.reports;
      const countlist = response.data.countlist;
      const countFBList = response.data.countFBList;
      this.setState({ reports, countlist, countFBList });
      if (response.data.cacheTTL && response.data.cacheTTL < expiredTime * 60) {
        await this.clearCacheReports(startDate, endDate, { value: category });
        this.getMetrics(this.state.date, category);
        this.showSnackBar({
          mess: `Dữ liệu vừa mới cập nhật!`,
          type: "success",
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  async setStateReportGA(cat, startDate, endDate) {
    const params = new URLSearchParams(window.location.search);
    const url =
      process.env.REACT_APP_API +
      `/${params.get("version") ? params.get("version") : "gas"}/analytics`;

    await axios
      .get(
        url,
        {
          params: {
            startDate,
            endDate,
            category: cat.value,
          },
        },
        {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }
      )
      .then((response) => {
        // do something with response
        // console.log(response);
        let reports = response.data.reports;
        const countlist = response.data.countlist;
        const countFBList = response.data.countFBList;
        reports.push(countlist);
        reports.push(countFBList);
        reportByCat.report = reports;
        return reportByCat; 
        // reportsList.push(reportByCat);
        // this.setState({reportsByCat: reportsList});
      })
      .catch((error) => console.log(error));
  }
  getMetricsByCat = async (daterange, categories) => {
    const range = daterange.map(
      (date) =>
        `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(
          date.getDate(),
          2
        )}`
    );
    const startDate = range[0];
    const endDate = range[1];
    const params = new URLSearchParams(window.location.search);
    const url =
      process.env.REACT_APP_API +
      `/${params.get("version") ? params.get("version") : "gas"}/analytics`;
    let promises = [];
    let reportsList = [];
    let reportsBySourceCat = [];
    let reportsBySource = {
      sum: 0,
      fb: 0,
      baomoi: 0,
      coccoc: 0,
      direct: 0,
      google: 0,
    };
    //add cat
    for (const category of categories) {
      let reportByCat = {
        value: null,
        report: {
          count: null,
          sum: null,
          google: null,
          fb: null,
        },
      };
      let reportBySource = {
        value: null,
        report: {},
      };
      let reportByCatSource = {
        value: null,
        report: {},
      };
      reportByCat.value = category.value;
      reportByCatSource.value = category.value;
      // reportBySource.value = category.value;
      reportsList.push(reportByCat);
      reportsBySourceCat.push(reportByCatSource);
      // reportsBySource.push(reportBySource);
    }

    this.setState({ reportsByCat: reportsList });
    console.log(reportsBySourceCat);
    this.setState({ reportsBySourceCat });

    //theo dòng
    let sumData = {
      sum: 0,
      fb: 0,
      google: 0,
      count: {
        countList: 0,
        countFBList: 0,
      },
    };
    for (const [index, category] of categories.entries()) {
      if (category.value != "khac") {
        let objIndex = reportsList.findIndex(
          ({ value }) => value === category.value
        );
        await axios
          .get(
            url,
            {
              params: {
                startDate,
                endDate,
                category: category.value,
              },
            },
            {
              headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }
          )
          .then((response) => {
            // console.log(response.data)
            reportsList[objIndex].report.sum = {
              reports: [response.data.reports[0]],
            };

            reportsList[objIndex].report.fb = {
              reports: [response.data.reports[1]],
            };

            reportsList[objIndex].report.google = {
              reports: [response.data.reports[2]],
            };

            reportsList[objIndex].report.count = {
              countList: response.data.countList,
              countFBList: response.data.countFBList,
            };

            if (category.value != "") {
              if(response.data.reports[0].data){
                sumData.sum += parseInt(
                  response.data.reports[0].data.totals[0].values[0]
                );
              }
              if(response.data.reports[0].rows){
                sumData.sum += parseInt(
                  response.data.reports[0].rows[0].metricValues[0].value
                );
              }
              if(response.data.reports[1].data){
                sumData.fb += parseInt(
                  response.data.reports[1].data.totals[0].values[0]
                );
              }
              if(response.data.reports[1].rows){
                sumData.fb += parseInt(
                  response.data.reports[1].rows[0].metricValues[0].value
                );
              }
              if(response.data.reports[2].data){
                sumData.google += parseInt(
                  response.data.reports[2].data.totals[0].values[0]
                );
              }
              if(response.data.reports[2].rows){
                sumData.google += parseInt(
                  response.data.reports[2].rows[0].metricValues[0].value
                );
              }
              
              sumData.count.countList += parseInt(response.data.countList);
              sumData.count.countFBList += parseInt(response.data.countFBList);
            }

            if (response.data && response.data.cacheTTL) {
              const { cacheTTL } = response.data;

              if (cacheTTL < expiredTime * 60) {
                // save category to revalidate cache later
                this.setState({
                  staleCategories: this.state.staleCategories.concat([
                    category,
                  ]),
                });
              }
            }

            this.setState({
              hasReportDataCategories: this.state.hasReportDataCategories.concat(
                [category]
              ),
            });

            // console.log(reportsList[objIndex]);
            this.setState({ reportsByCat: reportsList });
            this.setState({ sumreportsByCat: sumData });
          })
          .catch((error) => console.log(error));
      } else {
        let objIndex = reportsList.findIndex(
          ({ value }) => value === category.value
        );

        let tmpKhac = JSON.parse(JSON.stringify(reportsList[objIndex - 1]));
        console.log(tmpKhac);
        // console.log(sumData);
        // console.log(sumData.sum);
        // console.log(parseInt(tmpTong.report.sum.reports[0].data.totals[0].values[0]));
        // console.log(parseInt(tmpTong.report.sum.reports[0].data.totals[0].values[0]) - this.state.sumreportsByCat.sum);
        if(params.get("version") == 'gav4s'){
          tmpKhac.report.sum.reports[0].rows[0].metricValues[0].value =
            parseInt(
              parseInt(tmpKhac.report.sum.reports[0].rows[0].metricValues[0].value) -
                sumData.sum
            ) > 0
              ? parseInt(
                  parseInt(
                    tmpKhac.report.sum.reports[0].rows[0].metricValues[0].value
                  ) - sumData.sum
                )
              : 0;
          tmpKhac.report.fb.reports[0].rows[0].metricValues[0].value =
            parseInt(
              parseInt(tmpKhac.report.fb.reports[0].rows[0].metricValues[0].value) -
                sumData.fb
            ) > 0
              ? parseInt(
                  parseInt(
                    tmpKhac.report.fb.reports[0].rows[0].metricValues[0].value
                  ) - sumData.fb
                )
              : 0;
          tmpKhac.report.google.reports[0].rows[0].metricValues[0].value =
            parseInt(
              parseInt(
                tmpKhac.report.google.reports[0].rows[0].metricValues[0].value
              ) - sumData.google
            ) > 0
              ? parseInt(
                  parseInt(
                    tmpKhac.report.google.reports[0].rows[0].metricValues[0].value
                  ) - sumData.google
                )
              : 0;
        }
        else{
          tmpKhac.report.sum.reports[0].data.totals[0].values[0] =
            parseInt(
              parseInt(tmpKhac.report.sum.reports[0].data.totals[0].values[0]) -
                sumData.sum
            ) > 0
              ? parseInt(
                  parseInt(
                    tmpKhac.report.sum.reports[0].data.totals[0].values[0]
                  ) - sumData.sum
                )
              : 0;
          tmpKhac.report.fb.reports[0].data.totals[0].values[0] =
            parseInt(
              parseInt(tmpKhac.report.fb.reports[0].data.totals[0].values[0]) -
                sumData.fb
            ) > 0
              ? parseInt(
                  parseInt(
                    tmpKhac.report.fb.reports[0].data.totals[0].values[0]
                  ) - sumData.fb
                )
              : 0;
          tmpKhac.report.google.reports[0].data.totals[0].values[0] =
            parseInt(
              parseInt(
                tmpKhac.report.google.reports[0].data.totals[0].values[0]
              ) - sumData.google
            ) > 0
              ? parseInt(
                  parseInt(
                    tmpKhac.report.google.reports[0].data.totals[0].values[0]
                  ) - sumData.google
                )
              : 0;
        }
        


        tmpKhac.report.count.countList =
          tmpKhac.report.count.countList - sumData.count.countList > 0
            ? tmpKhac.report.count.countList - sumData.count.countList
            : 0;
        tmpKhac.report.count.countFBList =
          tmpKhac.report.count.countFBList - sumData.count.countFBList > 0
            ? tmpKhac.report.count.countFBList - sumData.count.countFBList
            : 0;
        reportsList[objIndex] = tmpKhac;
        reportsList[objIndex].value = "khac";
        // console.log(reportsList[objIndex]);
        this.setState({ reportsByCat: reportsList });
      }
    }
    //theo cột
    let types = this.typesOptions;
    //lấy pageview so sánh theo nguồn
    for (const type of types) {
      await axios
        .get(
          url,
          {
            params: {
              startDate,
              endDate,
              type,
              category: "",
            },
          },
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then((response) => {
          // console.log(response.data)
          reportsBySource[type] = response.data;
          if (response.data && response.data.cacheTTL) {
            const { cacheTTL } = response.data;

            if (cacheTTL < expiredTime * 60) {
              // save category to revalidate cache later
              this.setState({
                staleTypes: this.state.staleTypes.concat([type]),
              });
            }
          }

          this.setState({
            hasReportDataTypes: this.state.hasReportDataTypes.concat([type]),
          });

          this.setState({ reportsBySource });
        })
        .catch((error) => console.log(error));
    }

    //theo dòng so sánh
    let sumDataSource = {
      now: 0,
      past: 0,
    };
    for (const [index, category] of categories.entries()) {
      if (category.value != "khac") {
        let objIndex = reportsBySourceCat.findIndex(
          ({ value }) => value === category.value
        );
        await axios
          .get(
            url,
            {
              params: {
                startDate,
                endDate,
                type: "sum",
                category: category.value,
              },
            },
            {
              headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }
          )
          .then((response) => {
            // console.log(response.data)
            reportsBySourceCat[objIndex].report = {
              reports: [response.data.reports[0]],
              reports2: [response.data.reports2[0]],
            };

            if (category.value != "") {
              if(response.data.reports[0].data){
                sumDataSource.now += parseInt(
                  response.data.reports[0].data.totals[0].values[0]
                );
              }
              if(response.data.reports[0].rows && response.data.reports2[0].rows[0].metricValues){
                sumDataSource.now += parseInt(
                  response.data.reports[0].rows[0].metricValues[0].value
                );
              }
              if(response.data.reports2[0].data && response.data.reports2[0].rows[0].metricValues){
                sumDataSource.past += parseInt(
                  response.data.reports2[0].data.totals[0].values[0]
                );
              }
              if(response.data.reports2[0].rows && response.data.reports2[0].rows[0].metricValues){
                sumDataSource.past += parseInt(
                  response.data.reports2[0].rows[0].metricValues[0].value
                );
              }
            }

            if (response.data && response.data.cacheTTL) {
              const { cacheTTL } = response.data;

              if (cacheTTL < expiredTime * 60) {
                // save category to revalidate cache later
                this.setState({
                  staleCatsSource: this.state.staleCatsSource.concat([
                    category,
                  ]),
                });
              }
            }

            this.setState({
              hasReportDataCatsSource: this.state.hasReportDataCatsSource.concat(
                [category]
              ),
            });

            // console.log(reportsList[objIndex]);
            this.setState({ reportsBy: reportsList });
            this.setState({ sumreportsByCat: sumDataSource });
          })
          .catch((error) => console.log(error));
      } else {
        let objIndex = reportsBySourceCat.findIndex(
          ({ value }) => value === category.value
        );

        let tmpKhac = JSON.parse(
          JSON.stringify(reportsBySourceCat[objIndex - 1])
        );
        if(tmpKhac && tmpKhac.report && tmpKhac.report.reports[0]){
          if(tmpKhac.report.reports[0].rows && params.get("version") == 'gav4s'){
            tmpKhac.report.reports[0].rows[0].metricValues[0].value =
              parseInt(
                parseInt(tmpKhac.report.reports[0].rows[0].metricValues[0].value) -
                  sumDataSource.now
              ) > 0
                ? parseInt(
                    parseInt(tmpKhac.report.reports[0].rows[0].metricValues[0].value) -
                      sumDataSource.now
                  )
                : 0;
            tmpKhac.report.reports2[0].rows[0].metricValues[0].value =
              parseInt(
                parseInt(tmpKhac.report.reports2[0].rows[0].metricValues[0].value) -
                  sumDataSource.past
              ) > 0
                ? parseInt(
                    parseInt(tmpKhac.report.reports2[0].rows[0].metricValues[0].value) -
                      sumDataSource.past
                  )
                : 0;
  
          }
          else{
            tmpKhac.report.reports[0].data.totals[0].values[0] =
              parseInt(
                parseInt(tmpKhac.report.reports[0].data.totals[0].values[0]) -
                  sumDataSource.now
              ) > 0
                ? parseInt(
                    parseInt(tmpKhac.report.reports[0].data.totals[0].values[0]) -
                      sumDataSource.now
                  )
                : 0;
            tmpKhac.report.reports2[0].data.totals[0].values[0] =
              parseInt(
                parseInt(tmpKhac.report.reports2[0].data.totals[0].values[0]) -
                  sumDataSource.past
              ) > 0
                ? parseInt(
                    parseInt(tmpKhac.report.reports2[0].data.totals[0].values[0]) -
                      sumDataSource.past
                  )
                : 0;
  
          }  
        }
        
        
        reportsBySourceCat[objIndex] = tmpKhac;
        reportsBySourceCat[objIndex].value = "khac";

        this.setState({ reportsBySourceCat });
      }
    }
  };

  clearCacheAnalytics = async (startDate, endDate, category) => {
    const params = {
      category: category.value,
      endDate: endDate,
      startDate: startDate,
    };
    const paramsVersion = new URLSearchParams(window.location.search);
    const headers = {
      "Content-Type": "application/json;charset=utf-8",
    };

    await axios.post(
      `${process.env.REACT_APP_API}/clear-cache-analytics${paramsVersion.get("version") ? "-" + paramsVersion.get("version") : ""}`,
      { params },
      { headers }
    );
  };

  clearCacheReports = async (startDate, endDate, category) => {
    const params = {
      category: category.value,
      endDate: endDate,
      startDate: startDate,
    };
    const paramsVersion = new URLSearchParams(window.location.search);
    const headers = {
      "Content-Type": "application/json;charset=utf-8",
    };

    await axios.post(
      `${process.env.REACT_APP_API}/clear-cache-reports${paramsVersion.get("version") ? "-" + paramsVersion.get("version") : ""}`,
      { params },
      { headers }
    );
  };

  revalidateStaleCategories = async () => {
    const { date: daterange, staleCategories } = this.state;
    const range = daterange.map(
      (date) =>
        `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(
          date.getDate(),
          2
        )}`
    );
    const startDate = range[0];
    const endDate = range[1];
    const params = new URLSearchParams(window.location.search);
    const url =
      process.env.REACT_APP_API +
      `/${params.get("version") ? params.get("version") : "gas"}/analytics`;
    let sumData = {
      sum: 0,
      fb: 0,
      google: 0,
      count: {
        countList: 0,
        countFBList: 0,
      },
    };
    let types = this.typesOptions;
    for (const staleCategory of staleCategories) {
      if (staleCategory.value != "khac") {
        await this.clearCacheAnalytics(startDate, endDate, staleCategory);
        const response = await axios.get(
          url,
          {
            params: {
              startDate,
              endDate,
              category: staleCategory.value,
            },
          },
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        );

        const objIndex = this.state.reportsByCat.findIndex(
          ({ value }) => value === staleCategory.value
        );
        const newReportsByCat = [...this.state.reportsByCat];
        newReportsByCat[objIndex].report.sum = {
          reports: [response.data.reports[0]],
        };
        newReportsByCat[objIndex].report.fb = {
          reports: [response.data.reports[1]],
        };
        newReportsByCat[objIndex].report.google = {
          reports: [response.data.reports[2]],
        };
        newReportsByCat[objIndex].report.count = {
          countList: response.data.countList,
          countFBList: response.data.countFBList,
        };
        if (staleCategory.value != "") {
          sumData.sum += parseInt(
            response.data.reports[0].data.totals[0].values[0]
          );
          sumData.fb += parseInt(
            response.data.reports[1].data.totals[0].values[0]
          );
          sumData.google += parseInt(
            response.data.reports[2].data.totals[0].values[0]
          );
          sumData.count.countList += parseInt(response.data.countList);
          sumData.count.countFBList += parseInt(response.data.countFBList);
        }
      } else {
        let objIndex = this.state.reportsByCat.findIndex(
          ({ value }) => value === staleCategory.value
        );
        const newReportsByCat = [...this.state.reportsByCat];
        let tmpKhac = JSON.parse(JSON.stringify(newReportsByCat[objIndex - 1]));
        tmpKhac.report.sum.reports[0].data.totals[0].values[0] =
          parseInt(
            parseInt(tmpKhac.report.sum.reports[0].data.totals[0].values[0]) -
              sumData.sum
          ) > 0
            ? parseInt(
                parseInt(
                  tmpKhac.report.sum.reports[0].data.totals[0].values[0]
                ) - sumData.sum
              )
            : 0;
        tmpKhac.report.fb.reports[0].data.totals[0].values[0] =
          parseInt(
            parseInt(tmpKhac.report.fb.reports[0].data.totals[0].values[0]) -
              sumData.fb
          ) > 0
            ? parseInt(
                parseInt(
                  tmpKhac.report.fb.reports[0].data.totals[0].values[0]
                ) - sumData.fb
              )
            : 0;
        tmpKhac.report.google.reports[0].data.totals[0].values[0] =
          parseInt(
            parseInt(
              tmpKhac.report.google.reports[0].data.totals[0].values[0]
            ) - sumData.google
          ) > 0
            ? parseInt(
                parseInt(
                  tmpKhac.report.google.reports[0].data.totals[0].values[0]
                ) - sumData.google
              )
            : 0;
        tmpKhac.report.count.countList =
          tmpKhac.report.count.countList - sumData.count.countList > 0
            ? tmpKhac.report.count.countList - sumData.count.countList
            : 0;
        tmpKhac.report.count.countFBList =
          tmpKhac.report.count.countFBList - sumData.count.countFBList > 0
            ? tmpKhac.report.count.countFBList - sumData.count.countFBList
            : 0;
        newReportsByCat[objIndex] = tmpKhac;
        newReportsByCat[objIndex].value = "khac";
      }
      this.setState({ reportsByCat: newReportsByCat });
    }
  };
  revalidateStaleCatsSource = async () => {
    const { date: daterange, staleCatsSource } = this.state;
    const range = daterange.map(
      (date) =>
        `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(
          date.getDate(),
          2
        )}`
    );
    const startDate = range[0];
    const endDate = range[1];
    const params = new URLSearchParams(window.location.search);
    const url =
      process.env.REACT_APP_API +
      `/${params.get("version") ? params.get("version") : "gas"}/analytics`;
    let sumData = {
      now: 0,
      past: 0,
    };
    let type = "sum";
    for (const staleCategory of staleCatsSource) {
      if (staleCategory.value != "khac") {
        await this.clearCacheAnalytics(startDate, endDate, staleCategory);
        const response = await axios.get(
          url,
          {
            params: {
              startDate,
              endDate,
              type,
              category: staleCategory.value,
            },
          },
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        );

        const objIndex = this.state.reportsBySourceCat.findIndex(
          ({ value }) => value === staleCategory.value
        );
        const newReportsByCat = [...this.state.reportsBySourceCat];
        newReportsByCat[objIndex] = response.data;

        if (staleCategory.value != "") {
          sumData.now += parseInt(
            response.data.reports[0].data.totals[0].values[0]
          );
          sumData.past += parseInt(
            response.data.reports2[0].data.totals[0].values[0]
          );
        }
      } else {
        let objIndex = this.state.reportsBySourceCat.findIndex(
          ({ value }) => value === staleCategory.value
        );
        const newReportsByCat = [...this.state.reportsBySourceCat];
        let tmpKhac = JSON.parse(JSON.stringify(newReportsByCat[objIndex - 1]));
        tmpKhac.report.reports[0].data.totals[0].values[0] =
          parseInt(
            parseInt(tmpKhac.report.reports[0].data.totals[0].values[0]) -
              sumData.now
          ) > 0
            ? parseInt(
                parseInt(tmpKhac.report.reports[0].data.totals[0].values[0]) -
                  sumData.now
              )
            : 0;
        tmpKhac.report.reports2[0].data.totals[0].values[0] =
          parseInt(
            parseInt(tmpKhac.report.reports2[0].data.totals[0].values[0]) -
              sumData.past
          ) > 0
            ? parseInt(
                parseInt(tmpKhac.report.reports2[0].data.totals[0].values[0]) -
                  sumData.past
              )
            : 0;
        newReportsByCat[objIndex] = tmpKhac;
        newReportsByCat[objIndex].value = "khac";
      }
      this.setState({ reportsBySourceCat: newReportsByCat });
    }
  };
  revalidateStaleTypes = async () => {
    const params = new URLSearchParams(window.location.search);
    const url =
      process.env.REACT_APP_API +
      `/${params.get("version") ? params.get("version") : "gas"}/analytics`;
    const { date: daterange, staleTypes } = this.state;
    const range = daterange.map(
      (date) =>
        `${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(
          date.getDate(),
          2
        )}`
    );
    const startDate = range[0];
    const endDate = range[1];
    //lấy pageview so sánh theo nguồn
    for (const staleType of staleTypes) {
      let staleCategory = "";
      await this.clearCacheAnalytics(
        startDate,
        endDate,
        staleCategory,
        staleType
      );
      await axios
        .get(
          url,
          {
            params: {
              startDate,
              endDate,
              type: staleType,
              category: staleCategory,
            },
          },
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }
        )
        .then((response) => {
          // console.log(response.data)
          reportsBySource[type] = response.data;
          this.setState({ reportsBySource });
        })
        .catch((error) => console.log(error));
    }
  };
  showSnackBar = (data) => {
    this.setState({
      snackBarData: data,
      snackBarStatus: true,
    });
  };

  render() {
    const {
      reports,
      canAccess,
      countlist,
      countFBList,
      date,
      reportsByCat,
    } = this.state;
    // console.log(reportsByCat);
    return (
      <>
        <Layout
          snackBarStatus={this.state.snackBarStatus}
          setSnackBarStatus={(value) =>
            this.setState({ snackBarStatus: value })
          }
          snackBarData={this.state.snackBarData}
        >
          {canAccess && (
            <div className="content-wrapper dashboard">
              <HeaderMobileComponent />
              <div className="content-header">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-6 align-self-center">
                      <button
                        className="btn btn-sm btn-primary mr10"
                        onClick={(e) => this.getMetrics(this.oneDayRange)}
                      >
                        Hôm qua
                      </button>
                      <button
                        className="btn btn-sm btn-primary mr10"
                        onClick={(e) => this.getMetrics(this.threeDaysRange)}
                      >
                        3 ngày trước
                      </button>
                      <button
                        className="btn btn-sm btn-primary mr10 my-1"
                        onClick={(e) => this.getMetrics(this.aWeekAgoRange)}
                      >
                        1 tuần trước
                      </button>
                      <button
                        className="btn btn-sm btn-primary mr10 my-1"
                        onClick={(e) => this.getMetrics(this.aMonthAgoRange)}
                      >
                        1 tháng trước
                      </button>
                      {/* <button className="btn btn-sm btn-primary mr10 my-1">Giải trí</button>
                  <button className="btn btn-sm btn-primary mr10 my-1">Phim ảnh</button> */}
                    </div>
                    <div className="col-sm-6 text-right mt-2 mt-lg-0">
                      <div className="row flex-row-reverse">
                        <div className="col-12 col-lg-3">
                          <Select
                            options={this.categoryOptions}
                            defaultValue={this.categoryOptions[0]}
                            onChange={this.onChangeCategory}
                          />
                        </div>
                        <div className="col mt-2 mt-lg-0">
                          <DateRangePicker
                            onChange={this.onChange}
                            value={this.state.date}
                            calendarIcon={
                              <i className="far fa-calendar-alt"></i>
                            }
                            maxDate={new Date()}
                            clearIcon=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <section className="content">
                <div className="container-fluid">
                  <Boxes
                    report={reports[0]}
                    reportFB={reports[3]}
                    countlist={countlist}
                    countFBList={countFBList}
                  />

                  <div className="row">
                    <div className="col-12">
                      <div className="card overview-chart">
                        <div className="card-header">
                          <h5 className="card-title">
                            <i className="fas fa-chart-area"></i>
                          </h5>
                          <div className="card-tools">
                            <ul className="nav nav-pills ml-auto">
                              <li className="nav-item">
                                <a
                                  className="nav-link active"
                                  href="#chart-pageview"
                                  data-toggle="tab"
                                >
                                  Pageviews
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  href="#chart-session"
                                  data-toggle="tab"
                                >
                                  Sessions
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="tab-content p-0">
                            <div
                              className="chart tab-pane active"
                              id="chart-pageview"
                              style={{ position: "relative", height: "300px" }}
                            >
                              <ChartLine
                                type="pageviews"
                                report={reports[1]}
                                reportFB={reports[3]}
                                countlist={countlist}
                                countFBList={countFBList}
                              />
                            </div>
                            <div
                              className="chart tab-pane"
                              id="chart-session"
                              style={{ position: "relative", height: "300px" }}
                            >
                              <ChartLine
                                type="sessions"
                                report={reports[1]}
                                reportFB={reports[3]}
                                countlist={countlist}
                                countFBList={countFBList}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header border-transparent">
                      <h3 className="card-title">
                        <i className="far fa-newspaper"></i> Top Bài viết
                      </h3>
                      {/* <div className="card-tools col-5 col-md-2">
                    <Select
                      options={this.options}
                      defaultValue={this.options[0]}
  
                    />
                  </div> */}
                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="m-0 table table-striped table-valign-middle">
                          <tbody>
                            {reports[2] && reports[2].data ? (
                              reports[2].data.rows.map((row, idx) => {
                                return (
                                  <RecordRow
                                    report={row}
                                    key={`post-${idx}`}
                                    idx={`post-${idx}`}
                                    stt={idx}
                                  />
                                );
                              })
                            ) : (
                              <></>
                            )}

                            {reports[2] && reports[2].rows ? (
                              reports[2].rows.map((row, idx) => {
                                return (
                                  <RecordRow
                                    report={row}
                                    key={`post-${idx}`}
                                    idx={`post-${idx}`}
                                    stt={idx}
                                  />
                                );
                              })
                            ) : (
                              <></>
                            )}
                            {reports[2] &&
                            !reports[2].rows && !reports[2].data ? (
                              <tr className="odd">
                                <td
                                  valign="top"
                                  colSpan="8"
                                  className="dataTables_empty"
                                >
                                  Chưa có thông tin
                                </td>
                              </tr>
                            ) : (
                              <></>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/*<div className="card">
                  <div className="card-header border-transparent">
                    <h3 className="card-title">
                      <i className="far fa-newspaper"></i> Top Category
                    </h3>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <TableCategory report={reports[3]} />
                    </div>
                  </div>
                </div>*/}

                  {/*<div className="card">
                  <div className="card-header">
                    <h5 className="card-title">
                      <i className="fab fa-hotjar"></i> Trending
                    </h5>
                  </div>
                  <div className="card-body text-dark text-center">
                    <iframe
                      src="https://trends.google.com/trends/embed/dailytrends?geo=VN"
                      style={{ width: "100%", height: "380px", border: "unset" }}
                    ></iframe>
                  </div>
                </div>*/}

                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">
                        <i className="fas fa-project-diagram"></i> Thống kê
                      </h5>
                    </div>
                    <div className="card-body p-0 text-dark text-center">
                      <Analytics
                        categories={this.categoriesOptions}
                        date={this.state.date}
                        reportsByCat={this.state.reportsByCat}
                        revalidateStaleCategories={
                          this.revalidateStaleCategories
                        }
                        hasReportDataCategories={
                          this.state.hasReportDataCategories
                        }
                        showSnackBar={this.showSnackBar}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">
                        <i className="fas fa-bezier-curve"></i> So sánh nguồn
                      </h5>
                    </div>
                    <div className="card-body p-0 text-dark text-center">
                      <Compare
                        types={this.typesOptions}
                        date={this.state.date}
                        reportsBySource={this.state.reportsBySource}
                        revalidateStaleTypes={this.revalidateStaleTypes}
                        hasReportDataTypes={this.state.hasReportDataTypes}
                        showSnackBar={this.showSnackBar}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">
                        <i className="fas fa-code-branch"></i> So sánh nguồn
                        theo chuyên mục
                      </h5>
                    </div>
                    <div className="card-body p-0 text-dark text-center">
                      <CompareCat
                        categories={this.categoriesOptions}
                        date={this.state.date}
                        reportsBySourceCat={this.state.reportsBySourceCat}
                        revalidateStaleCatsSource={
                          this.revalidateStaleCatsSource
                        }
                        hasReportDataCatsSource={
                          this.state.hasReportDataCatsSource
                        }
                        showSnackBar={this.showSnackBar}
                      />
                    </div>
                  </div>
                </div>
              </section>

              <a href="/posts/new" className="dis-none mobi-dis-block">
                <button
                  type="button"
                  className="btn btn-lg rounded-circle bg-saostar fixed-bottom-right"
                >
                  <i className="fas fa-plus"></i>
                </button>
              </a>
            </div>
          )}
        </Layout>
      </>
    );
  }
}
export default connect((store) => {
  return {
    loginInfo: store.loginInfo,
    config: store.config,
  };
})(Dashboard);
